module.exports = "/_next/static/images/268fb21badd89bad2d3d78cd71f4851c-man-looking-at-phone@xs-2x.jpg";